<template>
    <div class="flex-grow-1 d-flex flex-column" style="max-height: 200px">
        <input type="color" ref="colorPicker">
    </div>
</template>

<script>
    export default {
        props: ['value'],
        mounted() {
            let app = this;
            $(this.$refs.colorPicker).spectrum({
                color: this.value ?? '#fff',
                flat: true,
                showInput: false,
                showButtons: false,
                move: function(color) {
                    app.$emit('input', color.toHexString());
                }
            });
        },
        watch: {
            value: function(newValue) {
                $(this.$refs.colorPicker).spectrum("set", newValue);
            }
        }
    }
</script>
